export { default as SplitText } from "./SplitText";
